export const CalendarTimeline = () => {
	return (
		<div class="timeline-view">
			<p>Timeline view coming soon...</p>
		</div>
	);
};
